/** Admin portal roles per rbac.txt */
export const ROLE = {
  SYSTEM_ADMINISTRATOR: "SystemAdministrator",
  ADMIN: "Admin",
  FINANCE: "Finance",
  AUDIT: "Audit",
  RSC_OFFICER: "RSCOfficer",
} as const;

export const VIEW_ONLY_ROLES = [ROLE.FINANCE, ROLE.AUDIT] as const;

/** Finance & Audit: all admin menus from rbac.txt */
export const ADMIN_PORTAL_MENU_ROLES = [
  ROLE.SYSTEM_ADMINISTRATOR,
  ROLE.ADMIN,
  ROLE.FINANCE,
  ROLE.AUDIT,
] as const;

export const AGENT_ROLES = ["MasterAgent", "SuperAgent", "SubAgent"] as const;

export function isSystemAdministrator(role?: string | null): boolean {
  return role === ROLE.SYSTEM_ADMINISTRATOR || role === ROLE.ADMIN;
}

export function isViewOnlyRole(role?: string | null): boolean {
  return VIEW_ONLY_ROLES.includes(role as (typeof VIEW_ONLY_ROLES)[number]);
}

/** Create / edit / delete / block on admin modules */
export function canModifyAdminData(role?: string | null): boolean {
  return isSystemAdministrator(role);
}

export function hasMenuPermission(
  userRole: string | undefined | null,
  allowedRoles: readonly string[]
): boolean {
  if (!userRole) return false;
  if (allowedRoles.includes(userRole)) return true;
  if (
    userRole === ROLE.SYSTEM_ADMINISTRATOR &&
    allowedRoles.includes(ROLE.ADMIN)
  ) {
    return true;
  }
  if (
    userRole === ROLE.ADMIN &&
    allowedRoles.includes(ROLE.SYSTEM_ADMINISTRATOR)
  ) {
    return true;
  }
  return false;
}

export function hasReportPermission(
  role: string | undefined | null,
  allowedRoles: readonly string[]
): boolean {
  return hasMenuPermission(role, allowedRoles);
}

export function getAgentTabsForRole(role?: string | null): string[] {
  if (isSystemAdministrator(role) || isViewOnlyRole(role)) {
    return ["Master Agents", "Super Agents", "Sub Agents"];
  }
  if (role === "MasterAgent") return ["Super Agents"];
  if (role === "SuperAgent") return ["Sub Agents"];
  return [];
}

export function getDefaultAgentTypeForRole(role?: string | null): string {
  return getAgentTabsForRole(role)[0] ?? "Master Agents";
}
